module.exports = __webpack_public_path__ + "img/twitter.98bb1f69.svg";